import { FileModel } from "../../models/fileModel";
import { EmaDataRowContentModel } from './emaDataRowContentModel';

export class EmaDataRowModel {
  public rawDataSourceId: number;
  public medicineName: string;
  public commonINNnames: string;
  public activeSubstances: string;
  public productNumber: string;
  public authorizationStatusId: number; //not needed for now. Hardcoded to 
  public atcCode: string;
  public authorizationHolderName: string;
  public revisionDate: string;
  public emaMedicineURL: string;
  public eparFileURLbg: string;
  public eparFileURLen: string;
  public numOfDocs: number;
  public isNumOfDocsDiff: boolean;
  public eparDocConfigId: number;
  public numOfLeaflets: number;
  public numOfSmPcs: number;
  public rowContent: Array<EmaDataRowContentModel>;
}